<template>
  <div class="contaier">
    <page-header></page-header>
    <div class="intro-box">
      <div class="intro-1">
        <div class="intro-">
          <div class="hq-title1">{{ $t('history.title') }}</div>
          <div class="intro">
            {{ $t('history.history') }}
          </div>
        </div>
      </div>

      <div class="img-box img-box_error">
        <img
          class="c-img"
          alt="hongqi"
          src="https://img.kamlung.net/hk/hongqi-contact/contact.jpg" />
      </div>
    </div>
    <!-- ------------------------ 内 ** ------------------------ -->
    <div class="model-box" id="highlights">
      <div class="model-lion">
        <swiper
          class=""
          :key="refreshKey"
          ref="swiperModel"
          :options="modelOptions">
          <swiper-slide :key="i" v-for="(item, i) in contactList">
            <div class="model-item">
              <div class="model-item_t">
                <div class="icon-box">
                  <i class="el-icon-arrow-down"></i>
                  <div class="circle"></div>
                </div>
                <div class="title">{{ item.year }}</div>
                <div class="text">{{ $t(`history.${item.year}`) }}</div>
              </div>
              <div class="img-box img-box_error">
                <!-- <img :src="item.img" class="model-img" /> -->
                <el-image
                  fit="cover"
                  :src="item.img"
                  class="main-img"
                  :preview-src-list="contactImgList">
                </el-image>
              </div>
            </div>
          </swiper-slide>
        </swiper>
      </div>
    </div>
    <footer-page></footer-page>
  </div>
</template>

<script>
import { throttle } from 'lodash'
import { langMixins } from '@/mixins/langMixins'
import { contactList, contactImgList } from '@/assets/js/static'
import PageHeader from '@/components/PageHeader.vue'
import FooterPage from '@/components/FooterPage.vue'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
export default {
  name: 'AboutUs',
  mixins: [langMixins],
  components: {
    PageHeader,
    FooterPage,
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      contactList: contactList.sort((a, b) => b.id - a.id),
      contactImgList,
      paramH: '1080px',
      modelOptions: {
        loop: false,
        spaceBetween: 60,
        slidesPerView: 2.6,
        freeMode: false,
        touchRatio: 0.2,
        slideToClickedSlide: true,
      },
      refreshKey: 1,
      scrollHandler: null,
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.scrollHandler = throttle(this.handleResize, 200)
      window.addEventListener('resize', this.scrollHandler)
      this.handleResize()
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
      this.langFn('/about')
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.scrollHandler)
  },
  methods: {
    handleResize() {
      let ww_ = window.innerWidth
      console.log('ww_ :>> ', ww_)
      if (ww_ < 768) {
        this.paramH = '320px'
        this.modelOptions.slidesPerView = 1.2
        this.modelOptions.spaceBetween = 20
        // this.modelOptions.centeredSlides =true
        // console.log('111111 :>> ')
      } else if (ww_ < 992) {
        this.paramH = '310px'
        this.modelOptions.slidesPerView = 2.2
        this.modelOptions.spaceBetween = 40
        // this.modelOptions.centeredSlides =true
      } else {
        this.paramH = '290px'
        // console.log('2222222 :>> ')
        this.modelOptions.slidesPerView = 2.6
        this.modelOptions.spaceBetween = 60
        // this.modelOptions.centeredSlides =true
      }
      this.refreshKey++
    },
  },
}
</script>

<style lang="scss" scoped>
.hq-title1 {
  line-height: 90px;
  font-size: 28px;
}
.contaier {
  // padding-top: 120px;
  .intro-box {
    // margin-top:110px;
    // padding-top:110px;
    padding-top: 120px;
    background-color: #000;
    .intro-1 {
      position: relative;
      // padding-top: 110px;
      // background-color: #000;
    }
    .intro- {
      max-width: 700px;
      position: absolute;
      top: 0px;
      left: 50%;
      transform: translateX(-50%);
      text-align: center;
      color: #fff;
      .intro {
        font-size: 16px;
      }
    }
    .img-box {
      width: 100%;
      aspect-ratio: 17 / 8.25;
      background-color: #f1f1f1;
      .c-img {
        aspect-ratio: 17 / 8.25;
        object-fit: cover;
      }
    }
  }
}

.model-box {
  padding: 60px 20px;
  .model-lion {
    border-top: #cea46c solid 2px;
    // padding-top: 20px;
  }
  .hq-title1 {
    padding: 60px 0;
  }
  .swiper-slide {
    // flex-shrink: 0;
    // width: 100%;
    height: auto;
    // position: relative;
    // transition-property: transform;
  }
  .model-item {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    .model-item_t {
      width: 100%;
      padding-bottom: 20px;
      .icon-box {
        display: flex;
        justify-content: center;
        // align-items: center;
        flex-direction: column;
        .el-icon-arrow-down {
          color: #cea46c;
        }
        .circle {
          width: 20px;
          height: 20px;
          border: #cea46c solid 4px;
          border-radius: 50%;
          background-color: #fff;
          // background-color: #000;
        }
      }
    }
    .title {
      font-size: 34px;
      padding-top: 1.2vw;
      padding-bottom: 1.4vw;
    }
    .text {
      // height: 180px;
      // height: 200px;
      // height: 140px;
      font-size: 18px;
    }
    .img-box {
      width: 100%;
      aspect-ratio: 16 / 8;
      .model-img {
        width: 100%;
        object-fit: cover;
        // max-height: 220px;
        aspect-ratio: 16 / 8;
        background-color: #fafafa;
      }
    }
  }
  /* 自定义箭头按钮 */
  //   .custom-arrow {
  //     position: absolute;
  //     top: 50%;
  //     transform: translateY(-50%);
  //     width: 44px;
  //     height: 44px;
  //     background: rgba(0, 0, 0, 0.6);
  //     backdrop-filter: blur(4px);
  //     border-radius: 50%;
  //     display: flex;
  //     align-items: center;
  //     justify-content: center;
  //     cursor: pointer;
  //     z-index: 10;
  //     transition: all 0.3s ease;
  //     opacity: 0.8;
  //   }

  //   .custom-arrow.prev {
  //     left: 20px;
  //   }

  //   .custom-arrow.next {
  //     right: 20px;
  //   }
}

@media (max-width: 1400px) {
  // .hq-title1 {
  //   line-height: 60px;
  //   font-size: 26px;
  // }
  // .contaier {
  //   .intro-box {
  //     .intro- {
  //       max-width: 720px;
  //       .intro {
  //       }
  //     }
  //     .c-img {
  //       object-fit: cover;
  //       aspect-ratio: 16 / 10;
  //     }
  //   }
  // }

  .model-box {
    //   .hq-title1 {
    //   }
    //   .model-item {
    //     .title {

    //     }
    .text {
      // height: 250px;
      //       font-size: 12px;
    }
    //     .model-img {

    //     }
    //   }
  }
}
@media (max-width: 992px) {
  .hq-title1 {
    line-height: 60px;
    font-size: 26px;
  }
  .contaier {
    .intro-box {
      .intro- {
        max-width: 720px;
        .intro {
          // font-size: 13px;
        }
      }
      .img-box {
        aspect-ratio: 16 / 10;
        .c-img {
          object-fit: cover;
          aspect-ratio: 16 / 10;
        }
      }
    }
  }

  .model-box {
    .hq-title1 {
      // padding: 60px 0;
    }
    .model-item {
      .title {
      }
      .text {
        // height: 310px;
        font-size: 16px;
      }
      .model-img {
        // width: 100%;
        // object-fit: cover;
        // max-height: 220px;
      }
    }
  }
}

@media (max-width: 768px) {
  .hq-title1 {
    // line-height: 50px;
    font-size: 24px;
  }
  .contaier {
    .intro-box {
      .intro- {
        width: 100%;
        max-width: 80%;
        .intro {
          font-size: 14px;
        }
      }
      .img-box {
        aspect-ratio: 16 / 12;
        .c-img {
          aspect-ratio: 16 / 12;
        }
      }
    }
  }
  .model-box {
    .hq-title1 {
      // padding: 60px 0;
    }
    .model-item {
      .title {
        // font-size: 34px;
        // padding-top: 1.2vw;
        // padding-bottom: 1.4vw;
      }
      .text {
        // height: 340px;
        font-size: 14px;
      }
      .model-img {
        // width: 100%;
        // object-fit: cover;
        // max-height: 220px;
      }
    }
  }
}
@media (max-width: 620px) {
  .hq-title1 {
    font-size: 22px;
  }
  .contaier {
    .intro-box {
      padding-top: 160px;
      .intro- {
        top: -70px;
        max-width: 90%;
        .intro {
        }
      }
      .img-box {
        aspect-ratio: 16 / 14;
        .c-img {
          aspect-ratio: 16 / 14;
        }
      }
    }
  }
  .model-box {
    .hq-title1 {
    }
    .model-item {
      .title {
        // font-size: 34px;
        // padding-top: 1.2vw;
        // padding-bottom: 1.4vw;
      }
      .text {
        // height: 400px;
        // font-size: 12px;
      }
      .model-img {
        // width: 100%;
        // object-fit: cover;
        // max-height: 220px;
      }
    }
  }
}
@media (max-width: 568px) {
  .hq-title1 {
    font-size: 22px;
  }
  .contaier {
    .intro-box {
      padding-top: 160px;
      .intro- {
        top: -70px;
        max-width: 90%;
        .intro {
          // font-size: 13px;
        }
      }
      .img-box {
        aspect-ratio: 16 / 14;
        .c-img {
          aspect-ratio: 16 / 14;
        }
      }
    }
  }
  .model-box {
    .hq-title1 {
      // padding: 60px 0;
    }
    .model-item {
      .title {
        // font-size: 34px;
        // padding-top: 1.2vw;
        // padding-bottom: 1.4vw;
      }
      .text {
        // height: 220px;
        // font-size: 12px;
      }
      .model-img {
        // width: 100%;
        // object-fit: cover;
        // max-height: 220px;
      }
    }
  }
}
@media (max-width: 468px) {
  // .hq-title1 {
  //   font-size: 22px;
  // }
  // .contaier {
  //   .intro-box {
  //     padding-top: 160px;
  //     .intro- {
  //       top: -70px;
  //       max-width: 90%;
  //       .intro {
  //       }
  //     }
  //     .img-box {
  //       aspect-ratio: 16 / 14;
  //       .c-img {
  //         aspect-ratio: 16 / 14;
  //       }
  //     }
  //   }
  // }
  .model-box {
    .hq-title1 {
      // padding: 60px 0;
    }
    .model-item {
      .title {
        // font-size: 34px;
        // padding-top: 1.2vw;
        // padding-bottom: 1.4vw;
      }
      .text {
        // height: 220px;
        // font-size: 12px;
      }
      .model-img {
        // width: 100%;
        // object-fit: cover;
        // max-height: 220px;
      }
    }
  }
}
</style>
